export default "__VITE_ASSET__im9pOgLg__"